// extracted by mini-css-extract-plugin
export default {"good":"index_good_ed5sq","change":"index_change_bHFWX","good1":"index_good1_yIEHt","change1":"index_change1_UEuKq","good2":"index_good2_FofCv","change2":"index_change2_HHFFL"};